import {
  Activity,
  Eye,
  LayoutDashboard,
  List
} from 'lucide-react';
import React from 'react';
import { NavLink } from 'react-router-dom';

export const navigationItems = [
  { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { name: 'Headset Pairing', href: '/headset-pairing', icon: Eye },
  { name: 'Sessions', href: '/sessions', icon: Activity },
  { name: 'Create Session Code', href: '/available-sessions', icon: List },
  /*
  { name: 'Analytics', href: '/analytics', icon: BarChart3 },
  { name: 'Settings', href: '/settings', icon: Settings },
  */
];

export const Navigation: React.FC = () => {
  return (
    <nav className="hidden md:block w-64 bg-white shadow-sm border-r border-secondary-200">
      <div className="p-6">
        <ul className="space-y-2">
          {navigationItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.name}>
                <NavLink
                  to={item.href}
                  className={({ isActive }) =>
                    `flex items-center space-x-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isActive
                      ? 'bg-primary-50 text-primary-700 border-r-2 border-primary-700'
                      : 'text-secondary-600 hover:bg-secondary-50 hover:text-secondary-900'
                    }`
                  }
                >
                  <Icon className="h-5 w-5" />
                  <span>{item.name}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};
